<template>
  <d2-container>
    <top-line :message="pageTitle" :iconclass="'fa fa-users'"></top-line>
    <el-row class="pagebody">
      <!-- 返回按钮 -->
      <el-row style="margin-bottom: 15px;">
        <el-button type="primary" icon="el-icon-back" size="medium" plain @click="goBack" />
      </el-row>
      <!-- 过滤栏 -->
      <el-row class="filter-bar">
        <el-card shadow="never">
          <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="200px" size="small">
            <el-row >
              <!-- 时间范围选择器 -->
              <el-col :span="10">
                <el-form-item label="时间范围：" class="search-item" :label-width="labelWidth">
                    <el-date-picker
                      v-model="period"
                      type="daterange"
                      align="right"
                      unlink-panels
                      range-separator="-"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      :picker-options="timePickerOptions"
                      @change="onDateChange"
                    />
                      
                  &nbsp;
                  <!-- 上个自然月、本月、下个自然月按钮 -->
                  <el-tooltip content="本月" placement="top">
                    <el-button type="primary" icon="el-icon-refresh-right" plain
                               @click="initDate" circle />
                  </el-tooltip>
                  
                </el-form-item>
              </el-col>
              <!-- 用户输入框 -->
              <el-col :span="8">
                <el-form-item label="用户：" prop="username" class="search-item" :label-width="labelWidth">
                  <el-input v-model="searchForm.username" style="width:175px" />
                </el-form-item>
              </el-col>
              <!-- 查询和重置按钮 -->
              <el-col :span="6">
                <el-button type="primary" icon="el-icon-search" size="small" plain style="margin-left:8px;"
                           class="fr"
                           @click="handleSearch">
                  查询
                </el-button>
                <el-button type="info" icon="el-icon-refresh-left" size="small" plain style="margin-left:8px;"
                           class="fr"
                           @click="handleReset">
                  重置
                </el-button>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </el-row>

      <!-- 表格 -->
      <el-row class="main-table">
        <el-table :data="tableData" border stripe>
          <el-table-column prop="date" label="日期"  width="120px"/>
          <el-table-column prop="namespace" label="用户" width="160px" />
          <el-table-column label="计费（元）" width="200px">
            <template slot-scope="scope">
              {{ parseFloat(scope.row.cost).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column prop="gpuModel" label="操作"  align="center"  width="160px">
            <template v-slot="scope" >
              <el-button type="text" size="mini" @click="showDetail(scope.row)">账单明细</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <!-- 分页 -->
      <el-row type="flex" justify="left" style="margin-top: 10px; margin-bottom: 18px;">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="pagination.page"
            :page-sizes="pagination.pageSizeList"
            :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total">
        </el-pagination>
      </el-row>
    </el-row>
  </d2-container>
</template>

<script>
import topLine from "@/components/save-common/topLine.vue";
import commonListMixin from "@/pages/mixin/mixin-common-list";

import util from '@/libs/util.js'

export default {
  name: "allns",
  mixins: [commonListMixin],
  components: {
    topLine,
  },
  data() {
    return {
      pageTitle: "自然日账单列表",
      labelWidth: '120px',
      tableDataApi: '/api/day-billing',

      searchForm: {
        username: '',
        start_time: '',
        end_time: '',
        month: ''
      },
      orgParams: {
        page: '', 
        pageSize: '',
        total: '',
      },
      period: [], // 绑定到日期范围选择器
      timePickerOptions: {
        disabledDate: (time) => {
          const specifiedMonth = this.searchForm.month;
          let baseDate;
          if (specifiedMonth) {
            const [year, month] = specifiedMonth.split('-').map(Number);
            baseDate = new Date(year, month - 1);
          } else {
            baseDate = new Date();
          }

          const targetYear = baseDate.getFullYear();
          const targetMonth = baseDate.getMonth(); // 0-based

          const thisMonthFirstDay = new Date(targetYear, targetMonth, 1);
          const nextMonthFirstDay = new Date(targetYear, targetMonth + 1, 1);

          return time < thisMonthFirstDay || time >= nextMonthFirstDay;
        }
      },
    };
  },
  watch: {
    'searchForm.month'(newMonth) {
      if (newMonth) {
        const selectedMonth = this.parseMonthString(newMonth); // 转成 Date 对象
        const { start, end } = this.getTargetMonthRange(selectedMonth);
        this.period = [start, end]; // 设置为该月的第一天和最后一天
        this.onDateChange(this.period); // 触发搜索
      }
    }
  },
  mounted() {
    this.loadParams();

    /// 如果没有 start_time 或 end_time，并且有 month，则根据 month 初始化时间范围
    if (this.searchForm.month) {
      const selectedMonth = this.parseMonthString(this.searchForm.month);
      const { start, end } = this.getTargetMonthRange(selectedMonth);
      this.period = [start, end];
      this.onDateChange(this.period);
    }

    this.getTableData();
  },

  methods: {
     loadParams() {
        const query = this.$route.query;
        if ('username' in query && query.username) {
          this.searchForm.username = query.username;
        }
        if ('start_time' in query && query.start_time) {
          this.searchForm.start_time = query.start_time;
          this.period[0] = query.start_time; // 设置 period 的开始时间
        }
        if ('end_time' in query && query.end_time) {
          this.searchForm.end_time = query.end_time;
          this.period[1] = query.end_time; // 设置 period 的结束时间
        }
        if ('month' in query && query.month) {
          this.searchForm.month = query.month;
        }
        if('orgPage' in this.$route.query && this.$route.query.orgPage) {
          this.orgParams.page = this.$route.query.orgPage
        }
        if('orgPageSize' in this.$route.query && this.$route.query.orgPageSize) {
          this.orgParams.pageSize = this.$route.query.orgPageSize
        }
        if('orgTotal' in this.$route.query && this.$route.query.orgTotal) {
          this.orgParams.total = this.$route.query.orgTotal
        }
      },

    handleReset () {
      this.searchForm = {
        username: '',
        start_time: '',
        end_time: '',
        month: ''
      };
      this.getTableData();
    },
    handleSearch () {
      this.getTableData();
    },
    
    goBack () {
      const backQuery = {
        // username: this.searchForm.username,
        start_time: this.searchForm.start_time,
        end_time: this.searchForm.end_time,
        page: this.orgParams.page,
        pageSize: this.orgParams.pageSize,
        total: this.orgParams.total,
      };

    // 推断 month 参数
    if (this.searchForm.start_time) {
      const date = new Date(this.searchForm.start_time);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      backQuery.month = `${year}-${month}`;
    }

    if (util.cookies.get('isAdmin') === 'true') {
      this.$router.push({
        path: '/user-billing-month',
        query: backQuery
      });
    } else {
      this.$router.push({
        path: '/userOrdin-billing-month',
        query: backQuery
      });
    }
    
  },
    parseMonthString(monthStr) {
      const [year, month] = monthStr.split('-').map(Number);
      return new Date(year, month - 1); // 注意：月份从 0 开始
    },
    // getTargetMonthRange(date) {
    //   const year = date.getFullYear();
    //   const month = date.getMonth();
    //   const firstDay = new Date(year, month, 1);
    //   const lastDay = new Date(year, month + 1, 0, 23, 59, 59, 999); // 当月最后一天最后一秒
    //   return { start: firstDay, end: lastDay };
    // },
    getTargetMonthRange(date) {
      const year = date.getFullYear();
      const month = date.getMonth(); // 0-based
      const firstDay = new Date(year, month, 1);
      const lastDay = new Date(year, month + 1, 0, 23, 59, 59, 999); // 最后一天最后一秒
      return {
        start: firstDay,
        end: lastDay
      };
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    onDateChange(value) {
      if (value && value.length === 2) {
        const startDate = new Date(value[0]);
        const endDate = new Date(value[1]);

        let specifiedMonth;
        if (this.searchForm.month) {
          const [year, month] = this.searchForm.month.split('-').map(Number);
          specifiedMonth = new Date(year, month - 1); // 注意：月份是 0-based
        } else {
          specifiedMonth = new Date(); // 默认用当前月
        }

        const targetYear = specifiedMonth.getFullYear();
        const targetMonth = specifiedMonth.getMonth(); // 0-based

        const isStartInTargetMonth =
          startDate.getFullYear() === targetYear &&
          startDate.getMonth() === targetMonth;

        const isEndInTargetMonth =
          endDate.getFullYear() === targetYear &&
          endDate.getMonth() === targetMonth;

        if (isStartInTargetMonth && isEndInTargetMonth) {
          this.searchForm.start_time = this.formatDate(startDate);
          this.searchForm.end_time = this.formatDate(endDate);
          this.getTableData(); // 根据新的时间范围获取数据
        } else {
          this.$message.warning(`请选择 ${targetYear}-${targetMonth + 1} 范围内的日期`);
          this.period = []; // 重置选择
          this.searchForm.start_time = '';
          this.searchForm.end_time = '';
        }
      }
    },

    initDate() {
      const selectedMonth = this.searchForm.month ? this.parseMonthString(this.searchForm.month) : new Date();
      const { start, end } = this.getTargetMonthRange(selectedMonth);
      this.period = [start, end];
      this.searchForm.start_time = start;
      this.searchForm.end_time = end;
      this.getTableData();
    },

     // 点击详情跳转明细
    showDetail(row) {
      this.$router.push({
        path: '/user-billing-details', // 请确认路径是否匹配您的路由
        query: {
          username: row.namespace,
          start_time: row.date,
          end_time: row.date,
          month: row.date.substr(0, 7),
          orgPage: this.orgParams.page,
          orgPageSize: this.orgParams.pageSize,
          orgTotal: this.orgParams.total,
          orgDetailPage: this.pagination.page,
          orgDetailPageSize: this.pagination.pageSize,
          orgDetailTotal: this.pagination.total,
        }
      });
    },
  }
}
</script>

<style scoped lang="scss">
.pagebody {
  margin-top: 20px;
  margin-left: 20px;
}
.filter-bar {
  margin-bottom: 10px;
}
.main-table {
  margin-top: 10px;
}

.search-button-line {
  display: flex;
  justify-content: flex-end;
}
.batch-button {
  min-width: 95px;
}
</style>